import { GenericObject, copyFields } from '@synergy/models';

import { ProductSnapshot } from '../../../common/models/product-snapshot';

export class DemandItem extends ProductSnapshot {
    public id?: number;
    public position?: number;
    public totalQuantity!: number;

    public static fromPlainObject(object: GenericObject): DemandItem {
        const demandItem = new DemandItem();

        // Import own keys
        copyFields(object, demandItem);

        // Import from base class (snapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite intersecting keys with base keys
        copyFields(productSnapshot, demandItem);

        demandItem.position = object?.['position'] ?? 0;

        return demandItem;
    }
}
